import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

export async function submitInquiry(payload) {
  const { data } = await api.post("/inquiries", payload);
  return data;
}

export async function uploadResume(formData) {
  const { data } = await api.post("/resume/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function getContactInfo() {
  const { data } = await api.get("/contact-info");
  return data;
}
